import { format } from "@swiggy-private/js-utils";

const toQuantityNumber = (quantity: number | string): number => {
    if (typeof quantity === "number") {
        return Number.isFinite(quantity) ? quantity : 0;
    }
    const parsed = Number(quantity);
    return Number.isFinite(parsed) ? parsed : 0;
};

/**
 * Returns the singular word when quantity is 1, otherwise the plural form.
 * Default plural appends `"s"` to `singular`; pass `plural` for irregular forms.
 *
 * @example getPluralizedWord(1, "Item") => "Item"
 * @example getPluralizedWord("2", "Item") => "Items"
 * @example getPluralizedWord(2, "child", "children") => "children"
 */
export const getPluralizedWord = (
    quantity: number | string,
    singular: string,
    plural?: string,
): string => {
    return toQuantityNumber(quantity) === 1 ? singular : plural ?? `${singular}s`;
};

/**
 * Formats `"{quantity} {label}"` with plural `"s"` append (or a custom plural word).
 *
 * @example formatQuantityLabel(1, "Item") => "1 Item"
 * @example formatQuantityLabel("2", "Item") => "2 Items"
 * @example formatQuantityLabel(2, "child", "children") => "2 children"
 */
export const formatQuantityLabel = (
    quantity: number | string,
    singular: string,
    plural?: string,
): string => {
    return format("{0} {1}", String(quantity), getPluralizedWord(quantity, singular, plural));
};
